import * as actionTypes from "./actionTypes";
import axios from "../../http/axios";
import { modifyDriver } from "../../utils/utils";

const getDriversSuccess = data => {
  return {
    type: actionTypes.GET_DRIVERS_LIST_SUCCESS,
    payload: data
  };
};

const getDriversFailed = error => {
  return {
    type: actionTypes.GET_DRIVERS_LIST_FAIL,
    error: error
  };
};

const getSingleDriverSuccess = data => {
  return {
    type: actionTypes.GET_SINGLE_DRIVER_SUCCESS,
    payload: data
  };
};

const getSingleFailed = error => {
  return {
    type: actionTypes.GET_SINGLE_DRIVER_FAIL,
    error: error
  };
};

const addDriverFailed = error => {
  return {
    type: actionTypes.ADD_DRIVER_FAILED,
    error: error
  };
};

export const getDrivers = (page, searchValue) => {
  return (dispatch, getState) => {
    dispatch({ type: "START_GET_DRIVERS" });
    let url = `/drivers/?page=${page}`;
    if (searchValue) {
      url = `${url}&search=${searchValue}`;
    }
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    axios
      .get(url, {
        headers: { Authorization: "JWT " + token }
      })
      .then(response => {
        dispatch(getDriversSuccess(response.data));
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        } else {
          dispatch(getDriversFailed(error));
        }
      });
  };
};

export const deleteDriver = id => {
  return (dispatch, getState) => {
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    return axios
      .patch(
        `/drivers/${id}/`,
        { is_deleted: true },
        {
          headers: { Authorization: "JWT " + token }
        }
      )
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const deactivateStatusChangeDialog = id => {
  return (dispatch, getState) => {
    const data = { show_notification: false };
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    axios
      .patch(`/admins/${id}/`, data, {
        headers: { Authorization: "JWT " + token }
      })
      .then(res => {
        localStorage.setItem("show_notification", false);
        dispatch({ type: actionTypes.STATUS_CHANGE_DIALOG_SUCCESS });
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const getDriver = id => {
  return (dispatch, getState) => {
    dispatch({ type: "START_GET_DRIVER" });
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    axios
      .get("/drivers/" + id + "/", {
        headers: { Authorization: "JWT " + token }
      })
      .then(response => {
        const driver = modifyDriver(response.data);
        dispatch(getSingleDriverSuccess(driver));
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        } else {
          dispatch(getSingleFailed(error));
        }
      });
  };
};

export const addDriver = data => {
  return (dispatch, getState) => {
    const url = "/drivers/";
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios.post(url, data, headers).catch(error => {
      if (error.response && error.response.status === 403) {
        dispatch({ type: actionTypes.AUTH_SIGNOUT });
      } else {
        dispatch(addDriverFailed(error));
      }
    });
  };
};

export const editDriver = (data, id) => {
  return (dispatch, getState) => {
    const url = `/drivers/${id}/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios.patch(url, data, headers).catch(error => {
      if (error.response && error.response.status === 403) {
        dispatch({ type: actionTypes.AUTH_SIGNOUT });
      } else {
        dispatch(addDriverFailed(error));
      }
    });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/driver.js